export default class ReportService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getReportOperatorFormData(id_operator, id_report) {
		return this.apiService.callGet('reports/operator_form_data', {id_operator: id_operator,id_report:id_report});
	}

	getEntities(params) {
		return this.apiService.callGet(''+params.id_operator+'/operator_reports', params)
	}

	exportCsv(params, format, type) {
		return this.apiService.callGetFile('reports/export/'+format+'/'+type, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ReportsOperatorService.js